"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _formElements = require("@mmc/form-elements");
var _commonCta = require("@mmc/common-cta");
var _text = require("@mmc/text");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _carSelectorTile = _interopRequireDefault(require("./car-selector-tile"));
var _vehicle = require("./vehicle.utils");
var _carSelectorGrid = require("./car-selector-grid.props/car-selector-grid.propTypes");
var _carSelectorGrid2 = _interopRequireDefault(require("../styles/car-selector-grid.css"));
var _DataUtils = new _mmcDataUtilities["default"](),
  formatAsMKSPath = _DataUtils.formatAsMKSPath;
var prepareProductForDataLayer = function prepareProductForDataLayer(product, currencyFormat) {
  if (product) {
    var clonedProduct = JSON.parse(JSON.stringify(product));
    if (clonedProduct.cta && clonedProduct.cta.url) {
      clonedProduct.cta.url = formatAsMKSPath(clonedProduct.cta.url);
    }
    if (clonedProduct.price) {
      clonedProduct.price.currency = currencyFormat;
    }
    return clonedProduct;
  }
  return product;
};
var CarSelectorGrid = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CarSelectorGrid, _React$Component);
  // All components need a resourceType in order for AEM to be aware of its existence
  CarSelectorGrid.resourceType = function resourceType() {
    return 'CarSelector_2_0_0';
  };
  function CarSelectorGrid(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selected: null,
      filterActive: false,
      filterValues: [],
      selectedYear: '',
      zipCode: '',
      isShowError: false
    };
    _this.updateSelected = _this.updateSelected.bind((0, _assertThisInitialized2["default"])(_this));
    _this.filterUpdate = _this.filterUpdate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseDownLink = _this.handleMouseDownLink.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  // eslint-disable-next-line react/no-deprecated
  var _proto = CarSelectorGrid.prototype;
  _proto.componentWillMount = function componentWillMount() {
    var data = this.props.data;
    if (data && data.modelYear) {
      this.filterUpdate(data, data.modelYear[0].year, true);
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    if (_jsCookie["default"].get(_vehicle.vehicleUtils.ZIP_CODE)) {
      this.setState({
        zipCode: _jsCookie["default"].get(_vehicle.vehicleUtils.ZIP_CODE)
      });
    }
  };
  _proto.handleMouseDownLink = function handleMouseDownLink(e, car) {
    var market = this.props.config.market;
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer && car && car.cta && car.cta.url && (car.cta.url.includes('/loquiero/configurador/configurador') || car.cta.url.includes('/comprar/configurador/configurador-veiculos') || car.cta.url.includes('/osta/rakenna-oma-mitsubishi/rakenna-autosi'))) {
      var model = car && car.name ? car.name.toLowerCase() : null;
      var price = car && car.price ? car.price.value : null;
      var currency = this.props.config.currencyFormat;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'car_configuration_click',
        comp_product: {
          position: 'page',
          vehicle_type: 'car',
          brand: 'mitsubishi',
          product_condition: 'new',
          model: model,
          version: null,
          color: null,
          upholstery: null,
          accesories: null,
          fuel_type: null,
          price: price,
          currency: currency.toLowerCase()
        }
      });
    }
    if (market.toLowerCase() === 'ro' && typeof window !== 'undefined' && window.dataLayer && car && car.cta && car.cta.url && car.cta.url.includes('/achizitie/configurator/configurator')) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'configurator_start',
        car_selected: car.name ? car.name.split(' ').map(function (n) {
          return n[0].toUpperCase() + n.slice(1).toLowerCase();
        }).join(' ') : ''
      });
    }
    if (market.toLowerCase() === 'nl' && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'configuratorStart',
        model: car == null ? void 0 : car.name
      });
    }
  };
  _proto.updateSelected = function updateSelected(selected) {
    this.setState({
      selected: selected
    });
  };
  _proto.filterUpdate = function filterUpdate(data, name, value) {
    var filterValuesLoc = [];
    for (var index = 0, len = data.modelYear.length; index < len; index += 1) {
      filterValuesLoc["y-" + data.modelYear[index].year] = false;
    }
    filterValuesLoc["y-" + name] = value;
    var filterActiveLoc = false;
    for (var _index = 0, _len = filterValuesLoc.length; _index < _len; _index += 1) {
      if (filterValuesLoc[_index] === true) {
        filterActiveLoc = true;
        break;
      }
    }
    this.setState({
      selectedYear: name,
      filterActive: filterActiveLoc,
      filterValues: filterValuesLoc
    });
  };
  _proto.renderTiles = function renderTiles(tiles, showSelection, theme, enableTwoColumns, customizedLabel) {
    var _this2 = this;
    if (!tiles || tiles.length === 0) {
      return '';
    }
    var dataSet = [];
    var _this$props = this.props,
      clickEvent = _this$props.clickEvent,
      changeEvent = _this$props.changeEvent,
      data = _this$props.data,
      selectedModels = _this$props.selectedModels,
      config = _this$props.config;
    var selectedModelCodes = [];
    if (selectedModels && selectedModels.length) {
      selectedModelCodes = selectedModels.map(function (model) {
        return model.code;
      });
    }
    var priceDisclaimerId = data.priceDisclaimerId,
      disclaimerData = data.disclaimerData,
      addPriceDisclaimer = data.addPriceDisclaimer;
    var _this$state = this.state,
      selected = _this$state.selected,
      filterActive = _this$state.filterActive,
      filterValues = _this$state.filterValues;
    if (filterActive) {
      for (var index = 0, len = tiles.length; index < len; index += 1) {
        if (filterValues["y-" + tiles[index].year]) dataSet.push(tiles[index]);
      }
    } else {
      dataSet = tiles;
    }
    return dataSet.map(function (car, i) {
      return /*#__PURE__*/_react["default"].createElement(_carSelectorTile["default"], {
        isForm: showSelection,
        key: car.id || i,
        itemIndex: i,
        theme: theme,
        data: car,
        updateSelected: _this2.updateSelected,
        selected: selected,
        clickEvent: clickEvent,
        changeEvent: changeEvent,
        mouseDownEvent: function mouseDownEvent(e) {
          return _this2.handleMouseDownLink(e, car);
        },
        enableTwoColumns: enableTwoColumns,
        customizedLabel: customizedLabel,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId,
        disclaimerData: disclaimerData,
        selectedModelCodes: selectedModelCodes,
        config: config
      });
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme;
    var _this$state2 = this.state,
      zipCode = _this$state2.zipCode,
      isShowError = _this$state2.isShowError,
      selectedYear = _this$state2.selectedYear;
    var codeSelector = {
      ctaEnabled: data.ctaEnabled ? data.ctaEnabled : false,
      ctaLabel: data.ctaLabel ? data.ctaLabel : '',
      ctaRedirectLink: data.ctaRedirectLink ? data.ctaRedirectLink : '#'
    };
    var codeEvent = function codeEvent() {
      // console.log('codeEvent - clickEvent');
    };
    var zipSelector = {
      zipCodeEnabled: data.zipCodeEnabled ? data.zipCodeEnabled : false,
      zipCodeHeadingText: data.zipCodeHeadingText ? data.zipCodeHeadingText : '',
      zipCodeLabel: data.zipCodeLabel ? data.zipCodeLabel : '',
      zipCodeErrorMsg: data.zipCodeErrorMsg ? data.zipCodeErrorMsg : 'Please enter a valid zip code',
      zipCode: data.zipCode && data.zipCode.validationRegEx ? data.zipCode : {
        validationRegEx: ''
      }
    };
    var zipEvent = function zipEvent(input) {
      _this3.setState({
        zipCode: input.value,
        isShowError: input.isShowError
      });
      if (input.value !== '' && input.isShowError === false) {
        _jsCookie["default"].set(_vehicle.vehicleUtils.ZIP_CODE, input.value);
      }
    };
    var yearSelector = {
      modelYearEnabled: data.modelYearEnabled ? data.modelYearEnabled : false,
      modelYearLabel: data.modelYearLabel ? data.modelYearLabel : '',
      modelYear: data.modelYear && data.modelYear.length > 0 ? data.modelYear : []
    };
    var yearEvent = function yearEvent(name, value) {
      _this3.filterUpdate(data, name, value);
    };

    /* destructure items off data that the component needs */
    var productTile = data.productTile,
      showSelection = data.showSelection,
      enableTwoColumns = data.enableTwoColumns,
      customizedLabel = data.customizedLabel,
      disclaimerData = data.disclaimerData;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _carSelectorGrid2["default"].outerContainer
    }, codeSelector.ctaEnabled && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorGrid2["default"].enterCodeButton
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      data: {
        label: codeSelector.ctaLabel,
        url: codeSelector.ctaRedirectLink,
        priority: 'low'
      },
      classes: [_carSelectorGrid2["default"].lowIconCta],
      clickEvent: codeEvent,
      changeEvent: codeEvent
    })))), zipSelector.zipCodeEnabled && /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-lg-10'] + " " + theme['col-lg-offset-1']
    }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: zipSelector.zipCodeHeadingText,
      className: _carSelectorGrid2["default"].subtitle,
      disclaimerData: disclaimerData
    }), /*#__PURE__*/_react["default"].createElement(_formElements.InputZipCode, {
      className: _carSelectorGrid2["default"].zipCodeInput,
      id: "zipCode",
      label: zipSelector.zipCodeLabel,
      theme: theme,
      name: "zipCode",
      value: zipCode,
      isShowError: isShowError,
      zipCodeDef: _vehicle.vehicleUtils.ZIP_CODE,
      errorMessage: zipSelector.zipCodeErrorMsg,
      onChange: zipEvent,
      pattern: zipSelector.zipCode.validationRegEx
    }))), yearSelector.modelYearEnabled && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _carSelectorGrid2["default"].modelYearContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _carSelectorGrid2["default"].tabButtonContainer + " " + theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_formElements.InputGroup, null, yearSelector.modelYear.map(function (year) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: year.id,
        name: year.year,
        type: "button",
        className: _carSelectorGrid2["default"].tabButton + " " + (selectedYear === year.year ? _carSelectorGrid2["default"].tabButtonActive : _carSelectorGrid2["default"].tabButtonRegular),
        onClick: function onClick(event) {
          return yearEvent(event.target.name, true);
        }
      }, year.year);
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-lg-10'] + " " + theme['col-lg-offset-1']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['container-fluid']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['middle-xs'] + " " + theme.row
    }, this.renderTiles(productTile, showSelection, theme, enableTwoColumns, customizedLabel, disclaimerData))))));
  };
  return CarSelectorGrid;
}(_react["default"].Component);
CarSelectorGrid.displayName = 'CarSelectorGrid';
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(CarSelectorGrid);
exports["default"] = _default;